<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <!-- <el-col :span="8" >
        <el-select v-model='businessIds' clearable multiple>
  			    <el-option
              v-for="item in getBusinessList_data.data||[]"
              :key="item.businessId"
              :label="item.businessName"
              :value="item.businessId">
            </el-option>
  		  </el-select>
      </el-col> -->
      <el-col :span="6" >
        <el-button
        v-if="addProjectBusiness"
           @click="$form('addProjectBusiness'),getProjectBusinessNotHas({pageSize:0})"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加业务
        </el-button>
      </el-col>
    </el-row>
    <myform
    :viewobj='{
        addProjectBusiness:  [ "新增项目业务", "el-icon-circle-plus" ]
      }'
      @close='$form("addProjectBusiness","reset"),getProjectBusiness({projectId})'
    @confirm='myformAddProjectBusiness' >
      <template v-slot:businessIds="{Myformdata}" >
  		  <el-select v-model='Myformdata.businessIds' clearable multiple>
  			    <el-option
              v-for="item in getProjectBusinessNotHas_data.data||[]"
              :key="item.businessId"
              :label="item.businessName"
              :value="item.businessId">
            </el-option>
  		  </el-select>
        <el-button type="primary" icon="el-icon-circle-plus"
        @click="$form('addProjectBusiness','submit').then(s=>getProjectBusiness({projectId:row.projectId}))">添加</el-button>
  	  </template>

      <hide slot='projectId' />
    </myform>

    <mytable
      :tableColums='tableColums_getProjectBusiness'
      api='getProjectBusiness'
      xupdateapi='updateBusiness'
      :height="H-165" >
    </mytable>
  </div>
</template>

<script>
export default {
  data() {
    return {
      businessIds:[],
      projectId:null,
      tableColums_getProjectBusiness: {
        $selection: false,
        businessName: '业务名称',
        $operation: this.deleteProjectBusiness && [
          '操作', 200,

          `@text: 删除#danger
         @click: _confirm('确定要删除吗?')
                 .trigger('deleteProjectBusiness',{pbId:$row.pbId})
                 .trigger('getProjectBusiness',{projectId})
        `,
        ],
      },


    };
  },

  watch: {

  },

  methods: {
    myformAddProjectBusiness(submit, Myformdata) {
      Myformdata.projectId = A.local('$projectId');
      submit();
    },
  },

  created() {
    this.getProjectBusiness({projectId:A.local('$projectId')});
    this.projectId=A.local('$projectId')
    console.log(this.Myformdata)
    this.getProjectBusinessNotHas();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/ProjectBusiness.vue